import React from 'react';
import { observer } from 'mobx-react-lite';
import bem from 'utils/bem';
import Text from 'components/Text';
import Model from '../../../../../model';

import './index.sass';

const { block, el } = bem('office-purchase-pay-success');

const OfficePurchasePaySuccess = () => {

    const { modal } = Model;

    const handleClose = () => {
        modal.closeCourseForm();
    }

    return (
        <div className={block()}>
            <div className={el('content')}>
                <div className={el('top-block')}>
                    <div className={el('stars')} />
                    <div className={el('message')}>
                        <div className={el('title')}>
                            <Text tag={'div'} serif>{`Ваш заказ успешно оплачен `}
                            </Text>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default observer(OfficePurchasePaySuccess);
